import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import {
  updateDeliveryNote,
  updateDeliveryNoteTouched,
  addDeliveryNote,
  getSupplierSuggestions
} from './actions'
import DeliveryNote from './deliveryNote';
import { semanticColors, greyScaleColors } from '../../../../Globals/styles';
import { isStringValid } from '../../../../Util/stringValidator'

class DeliveryNotes extends Component{
  shouldComponentUpdate = (nextProps) => {
    return nextProps.deliveryNotes!==this.props.deliveryNotes
  };
  addDeliveryNote = (index) => {
    if(index===this.props.deliveryNotes.length-1){
      this.props.dispatch(addDeliveryNote());
    }
  };
  isContainerActive = () => {
    const { deliveryNotes } = this.props;
    for (let i = 0; i < deliveryNotes.length; i++) {
      if(deliveryNotes[i].number || deliveryNotes[i].supplier)
        return true
    }
    return false
  };
  render()  {
    const { deliveryNotes, dispatch, supplierSuggestions } = this.props;
    let isAllValid = true;
    let deliveryNotesNodes = deliveryNotes.map((deliveryNote, index) => {
      let isNumberValid = (!deliveryNote.numberTouched || ((!isStringValid(deliveryNote.number) && !isStringValid(deliveryNote.supplier)) || isStringValid(deliveryNote.number)));
      let isSupplierValid = (!deliveryNote.supplierTouched || ((!isStringValid(deliveryNote.number) && !isStringValid(deliveryNote.supplier)) || isStringValid(deliveryNote.supplier)))
      if(!isNumberValid || !isSupplierValid)
        isAllValid = false
      return (
        <DeliveryNote
          key={index}
          deliveryNote={deliveryNote}
          isSupplierValid={isSupplierValid}
          isNumberValid={isNumberValid}
          updateDeliveryNote={(typeOf, value) => {
            dispatch(updateDeliveryNote(typeOf, index, value))
            this.addDeliveryNote(index)
          }}
          updateDeliveryNoteTouched={(typeOf) => dispatch(updateDeliveryNoteTouched(typeOf, index))}
          getSupplierSuggestions={(val) => dispatch(getSupplierSuggestions(val))}
          supplierSuggestions={supplierSuggestions}
        />
      )
    })

    return (
      <div style={styles.outerContainer}>
        <div className="row" style={[styles.container, this.isContainerActive() && styles.containerActive, !isAllValid && styles.containerError]}>
          <div style={styles.heading}>
            Følgesedler
          </div>
          <div>
            <div style={[styles.colHeading, styles.firstColumn]} className="col-xs-4">Nummer</div>
            <div style={styles.colHeading} className="col-xs-3">Leverandør</div>
            <div style={styles.colHeading} className="col-xs-4">Specifikation</div>
          </div>
          {deliveryNotesNodes}
        </div>
      </div>
    );
  }
}

var styles = {
  outerContainer: {
    margin: '0 0 12px 0',
    paddingRight: '12px'
  },
  container: {
    backgroundColor: greyScaleColors.greyLighter,
    padding: '2px 0 8px 6px',
    margin: '0',
    borderLeft: '2px solid ' + semanticColors.mainBackground
  },
  containerActive: {
    borderLeft: '2px solid ' + semanticColors.info
  },
  containerError: {
    borderLeft: '2px solid ' + semanticColors.danger
  },
  firstColumn: {
    paddingLeft: '0'
  },
  heading: {
    marginBottom: '5px'
  },
  colHeading:{
    fontSize: '12px',
    paddingBottom: '4px',
    textAlign: 'left'
  }
}


const selectProps = state => {
  return {
    ...state.dailyReportDeliveryNotesReducer
  };
}
  DeliveryNotes.propTypes = {
    deliveryNotes: PropTypes.arrayOf(PropTypes.shape({
      number: PropTypes.string.isRequired,
      supplier: PropTypes.string.isRequired,
      specification: PropTypes.string,
      numberTouched: PropTypes.bool,
      supplierTouched: PropTypes.bool
    })),
    supplierSuggestions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }))
  };
export default connect(selectProps)(Radium(DeliveryNotes));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/DeliveryNotes/index.js